type ArrowRightProps = {
  color?: string; // Optional color prop
  style?: object;
  height?: string;
  width?: string;
  viewBox?: string;
};

export const ArrowRight: React.FC<ArrowRightProps> = ({
  color = '#1C3A13',
  style,
  height,
  width,
  viewBox,
}) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width ?? '11'}
    height={height ?? '11'}
    fill='none'
    viewBox={viewBox ?? '0 0 11 11'}
    style={style}
  >
    <path
      fill={color === 'currentColor' ? 'currentColor' : color}
      fillRule='evenodd'
      d='M5.5 0 11 5.5 5.5 11 4.406 9.906l3.631-3.632H0V4.726h8.037L4.406 1.094 5.5 0Z'
      clipRule='evenodd'
    />
  </svg>
);
